import { LOCALE_ID } from '@angular/core';

export const ACTIVE_LOCALE_PROVIDER = {
  provide: LOCALE_ID,
  useFactory: () => localStorage.getItem('userLocale'),
};
